<template>
  <div>
    <div v-if="confirmAlert">
      <transition name="fade">
      <div class="alert-modal">
        <div class="alert-area">
            <div class="md:py-6  md:p-8 bg-white" id="alert_image_overlay">
                <div class="text-center pt-8 md:pt-0 login-selection-header pb-4">
                    Are you sure you want to <br class="md:hidden"/> delete this? 
                </div>
                <div class="flex delete-confirm-alert-content pb-8 lg:pb-0 w-full items-center justify-center">
                    <div class="flex pr-2">
                    <a @click="deleteCard(true)" class="new-app-btn cursor-pointer bg-blue mt-6 sm:mt-0 pr-4">
                        Yes
                    </a>
                    </div>
                    <div class="flex pl-2 ">
                    <a @click="deleteCard(false)" class="new-app-btn cursor-pointer bg-theme mt-6 sm:mt-0 ">
                        No
                    </a>
                    </div>
                </div>
          </div>
        </div>
      </div>
    </transition>
    </div>
     <div class="border border-dark border-opacity-25 lg:flex rounded-lg justify-between px-4 py-7.5">
    <div v-if="cards.length" class="grid md:grid-cols-2 lg:pr-4 lg:w-3/4 gap-4 xl:gap-7">
      <div
        v-for="(card, index) in cards"
        :key="`my-card-${index}`"
        class="p-7.5 bg-white border rounded-lg cursor-pointer"
        :class="selectedCardId === card.id ? 'border border-green bg-green-light shadow-md' : 'border-dark-b'"
        @click="selectCard(card.id)"
      >
        <div class="radio-parent-class" v-if="selectedCardId === card.id">
          <img class="radio-class" src="@/assets/images/green-checked.png" alt="">
        </div>
        <div class="radio-parent-class" v-else>
          <img class="radio-class" src="@/assets/images/green-uncheck.png" alt="">
        </div>
        <div class="pb-4">
          <p>**** **** **** {{ card.last4Digits }}</p>
          <p>{{card.expMonth}} / {{ card.expYear }}</p>
        </div>
        <p class="uppercase font-bold">{{ card.brand }}</p>
        <div class="pt-5">
          <a
            :disabled="deleteCardActive"
            class="flex delete-stripe-card items-center text-sm text-dark"
            @click.stop="deleteActive(card)"
          >
            <i class="icon-remove mr-2" />
            <span class="opacity-50 pt-1">Remove</span>
          </a>
        </div>
      </div>
    </div>
    <div v-else class="pt-8">No card found</div>
    <div class="md:w-full lg:w-content lg:text-right text-center lg:pt-0 pt-6 pb-1 lg:justify-self-end">
      <button
        class="rounded-full w-auto h-12 px-4 bg-dark-blue text-white text-xl font-medium"
        type="button"
        @click="isCardModalOpen = true"
      >
        Add New Card
      </button>
    </div>
    <NewCardModal @selectNewCard="selectNewCard" v-if="isCardModalOpen" @close="closeModal" />
  </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import NewCardModal from '@/shared/components/profile/payment/NewCardModal'


export default {
  name: 'CardPayment',
  props: {
    prevSelectedCard: {
      type: String,
      default: ''
    },
    isUserAvailable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cards: [],
      isCardModalOpen: false,
      selectedCardId: '',
      deleteCardActive: false,
      selectedCardtoDelete: '',
      confirmAlert: false
    }
  },
  components: {
    NewCardModal
  },
  watch: {
    cards() {
      this.$emit('isCardAvailable', this.cards.length > 0 ? true : false)  
    }
  },
  async mounted() {
    this.selectedCardId = this.prevSelectedCard
    this.cards = await this.fetchBuyerCards()
    this.$emit('isCardAvailable', this.cards.length > 0 ? true : false)

    if (this.prevSelectedCard && !this.cards.some(card => card.id === this.selectedCardId)) { // if address is availalbe
      if(this.isUserAvailable) {
        this.selectCard(this.cards[0].id)
      } else {
        this.selectedCardId = ''
        this.$emit('updateSelectedCard', this.selectedCardId)
      }
    } else { // else default selection of address is availalbe
      if(this.cards.length > 0 && !this.isUserAvailable) {
        this.selectCard(this.cards[0].id)
      } else {
        const isFound = this.cards.some(element => {
          if (element.id === this.prevSelectedCard) {
            return true;
          }
          return false;
        });
        if(!isFound && this.cards.length > 0) {
          this.selectCard(this.cards[0].id)
        }
      }
    }
  },
  methods: {
    ...mapActions ([
      'fetchBuyerCards',
      'deleteBuyerCard'
    ]),
    async fetchCards() {
      this.confirmAlert = false
      this.cards = await this.fetchBuyerCards()
    },
    closeModal(card) {
      this.isCardModalOpen = false
      if (card) this.fetchCards()
    },
    selectNewCard(selectedCardId) {
      this.selectCard(selectedCardId)
    },
    async deleteCard(deleteAction) {
        let selected_card = this.selectedCardId
        this.confirmAlert = false
        if(deleteAction && this.selectedCardtoDelete.id != '') {
            const response = await this.deleteBuyerCard(this.selectedCardtoDelete.id)
            this.$notify({
                group: 'buyHive',
                type: response.result ? 'success' : 'error',
                text: response.message,
                duration: 7000
            })
          const pos = this.cards.map(e => e.id).indexOf(this.selectedCardtoDelete.id);
          this.cards.splice(pos,1);
          this.$emit('isCardAvailable', this.cards.length > 0 ? true : false)

          if(this.cards.length == 0) { // if card length is 0, unselect the card using empty string
            this.selectCard('')
          } else if(selected_card == this.selectedCardtoDelete.id && this.cards.length > 0) { // if selected card was deleted & array of cards is not empty, then set new card
            this.selectCard(this.cards[0].id)
          } 
          
        } 
    },
    deleteActive(card) {
      this.confirmAlert = true;
      this.selectedCardtoDelete = card
    },
    selectCard(cardId) {
      if (this.selectedCardId === cardId) {
        this.selectedCardId = ''
        this.$emit('updateSelectedCard', this.selectedCardId)
      } else {
        this.selectedCardId = cardId
        this.$emit('updateSelectedCard', this.selectedCardId)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.radio-parent-class {
  position: relative;
  /* padding: 1em; */
}
.radio-parent-class .radio-class {
  position: absolute;
  right: -20px;
  top: -18px;

}

address-remove-parent {
  position: relative;
}
.address-remove-parent .address-remove {
  position: absolute;
  right: 12px;
  top: 25px;

}
  .address-selection {
    .address-box-lg {
      @apply p-6 border-2 rounded-lg cursor-pointer bg-white;
    }
    .address-box {
      @apply p-6 border-2 rounded-lg cursor-pointer bg-white;
    }
    .selected {
      @apply border-green shadow-lg;
    }
  }

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}
.new-app-btn {
  @apply rounded-full px-4 py-2 text-white;
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
}
.alert-modal {
    justify-content: center;
    align-items: center;
    @apply fixed px-5 h-full inset-0 bg-dark z-50 bg-opacity-50 text-base flex  transition-all duration-150 ease-linear;
    .alert-area {
      @apply z-10 m-auto align-middle rounded-lg w-full;
      @screen md { width: 680px; }
      &__content {
        @apply rounded-lg;
        max-height: calc(100vh - 10px);
        overflow: auto;
        &__header {
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
          button {
            @apply text-lg font-bold w-1/2 py-2.5;
            @screen md { @apply text-2xl }
          }
        }
        .switch { @apply relative inline-block w-20 h-9; }
        .switch input { @apply h-0 w-0 h-0; }

        .slider {
          @apply absolute cursor-pointer inset-0;
          background-color: #00B3C9;
          -webkit-transition: .4s;
          transition: .4s;
        }

        .slider:before {
          @apply absolute bg-white h-7 w-7;
          content: "";
          left: 4px;
          bottom: 4px;
          -webkit-transition: .4s;
          transition: .4s;
        }

        input:checked + .slider { background-color: #8DC63F; }
        input:focus + .slider { box-shadow: 0 0 1px #8DC63F; }
        .slider.round { border-radius: 34px; }
        .slider.round:before { border-radius: 50%; }

        input:checked + .slider:before {
          -webkit-transform: translateX(42px);
          -ms-transform: translateX(42px);
          transform: translateX(42px);
        }
        .info-box {
          @apply pt-5 px-6 pb-2;
          background: rgba(0, 179, 201, 0.2);
          @screen md { @apply px-12 }
        }
      }
    }

    /* width */
    ::-webkit-scrollbar { width: 4px; }

    /* Track */
    ::-webkit-scrollbar-track { background: rgba(35, 31, 32, 0.15); }

    /* Handle */
    ::-webkit-scrollbar-thumb { background: #a0aec0; }
  }
  .delete-confirm-alert-content {
  @media (max-width: 768px) {
    padding-bottom : 2rem;
  }
}
.login-selection-header {
    display: flex;
    justify-content: center;
    font-family: 'Avenir LT Pro';
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
}
#alert_image_overlay {
  @media (max-width: 768px) {
    /* width: 150%; */
    // padding-left: 3rem;
    // padding-right: 3rem;
  width: 70%; 
  }
  margin: 1em auto;
  position: relative;
  color: #024457;
  z-index: 1001;
  border-radius: 8px;
}
</style>